module.exports = __webpack_public_path__ + "assets/img/mobile_main_image.235457cd.jpg";